import React from 'react';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import DonutChart from '@/pages/dashboard/_charts/DonutChart';
import colors from 'tailwindcss/colors';
import {partnerResponses, stewardResponses} from './_invitationDeclineReasons';
import _ from 'lodash';
import {useEventsContext} from "@/pages/dashboard/EventsContext";

export default function InvitationDeclineReasonYear(props) {
  const {subtitle} = props;
  const {filteredInvitations, isLoadingInvitations} = useEventsContext();

  if (isLoadingInvitations) {
    return (
      <ChartLoader
        title="Breakdown of reasons for declining the invitation"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  // produce an array of objects like:
  // ```js
  // [
  // {
  //    isSteward: false,
  //    label: 'I'm swamped right now, ask me later.',
  //    regex: /case-insensitive regex for resp/,
  //    count: 0
  //  }
  // ]
  // ```
  const counts = _.flatMap([
    ...partnerResponses.map(resp => ({
      isSteward: false, label: resp,
      regex: new RegExp(_.escapeRegExp(resp), "i"),
      count: 0
    })),
    ...stewardResponses.map(resp => ({
      isSteward: true, label: `[Steward] ${resp}`,
      regex: new RegExp(_.escapeRegExp(resp), "i"),
      count: 0
    }))
  ])

  // match all the responses and increment the counts for each match
  for (const invitation of filteredInvitations) {
    const count = counts.find(count => count.regex.test(invitation.responseMessage));
    if (count) {
      count.count++;
    }
  }
  const sortedCounts = _.orderBy(counts, 'count', 'desc');

  const labels = sortedCounts.map(r => r.label);
  const series = sortedCounts.map(r => r.count);

  return (
    <DonutChart
      title="Breakdown of reasons for declining the invitation"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
      colors={[
        // colors.slate['400'],
        // colors.gray['400'],
        // colors.zinc['400'],
        // colors.neutral['400'],
        // colors.stone['400'],
        colors.red['400'],
        colors.orange['400'],
        // colors.amber['400'],
        colors.yellow['400'],
        colors.lime['400'],
        // colors.green['400'],
        colors.emerald['400'],
        colors.teal['400'],
        colors.cyan['400'],
        colors.sky['400'],
        colors.blue['400'],
        colors.indigo['400'],
        colors.violet['400'],
        // colors.purple['400'],
        colors.fuchsia['400'],
        colors.pink['400'],
        colors.rose['400']
      ]}
    />
  );
}
